import SubscriptionForm from "./SubscriptionForm";

export function Subscribe() {
  return (
    <div className="rounded-xl w-full bg-foreground/10 backdrop-blur p-6 text-white gap-5 flex flex-col">
      <h4 className="text-white">Hey, stop!</h4>
      <div className="relative">
        <SubscriptionForm />
      </div>
      <p className="text-white/60 text-xs">
        Yes, stop overpaying for imports. Get insider tips, trusted supplier
        lists, and exclusive deals delivered to your inbox weekly.
      </p>
    </div>
  );
}
